// TEMPORARY (SW-2417): Walmart Bentonville demo web app. Delete once the Walmart
// demonstration is complete.
// Mobile charge page reached from the charger 03A QR code. Requires login.
// Shows only live Command Console data (site details, telemetry, current
// pricing). When any of it is unavailable the page shows an error state and
// Start charging stays disabled. Nothing is made up.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { charger, money } from "ee-proto-interfaces";
import { PortTypeToString } from "ee-utils";
import { process } from "../Process";
// TEMPORARY (SW-2417): fixed hold for the Walmart Bentonville demo. There is no
// per-site hold setting in Command Console, so the demo uses this constant.
// Delete once the Walmart demonstration is complete.
var WALMART_DEMO_HOLD_CENTS = 1500;
var LOAD_ERROR_COPY = {
    "missing-ocppid": "Charger not found. Open your phone's camera app and scan the QR code on the charger.",
    session: "Your session has expired. Please sign in again.",
    "charger-not-found": "Charger not found for your account. Open your phone's camera app and scan the QR code on the charger.",
    "charger-info": "Charger info unavailable, please try again.",
};
var LoadError = /** @class */ (function (_super) {
    __extends(LoadError, _super);
    function LoadError(reason) {
        var _this = _super.call(this, reason) || this;
        _this.reason = reason;
        return _this;
    }
    return LoadError;
}(Error));
function normalizeConnectorLabel(raw) {
    if (!raw || !raw.trim()) {
        return undefined;
    }
    var upper = raw.trim().toUpperCase();
    if (upper === "CCS1" || upper === "CCS2" || upper === "CCS") {
        return "CCS";
    }
    if (upper.includes("NACS") || upper.includes("J3400")) {
        return "NACS";
    }
    return raw.trim();
}
function isSinglePortModel(modelName) {
    if (!modelName) {
        return false;
    }
    var normalized = modelName.trim().toLowerCase();
    return normalized === "eev3" || normalized.includes("single");
}
function formatMoneyPerKwh(moneyObj) {
    var _a;
    if (!moneyObj || moneyObj.amount === undefined) {
        return undefined;
    }
    var value = moneyObj.amount / Math.pow(10, ((_a = moneyObj.precision) !== null && _a !== void 0 ? _a : 2));
    return "$".concat(value.toFixed(2), "/kWh");
}
/** A port is available only when telemetry reports no reason, fault, or session. */
function isPortAvailable(port) {
    var _a;
    var reasons = ((_a = port.unavailableReasons) !== null && _a !== void 0 ? _a : []).filter(function (reason) {
        return reason !== charger.UnavailableReason.NONE &&
            reason !== "NONE";
    });
    return reasons.length === 0 && !port.faultCode && !port.transactionStarted;
}
function organizationIdsFromUser(user) {
    var _a, _b;
    if (!user) {
        return [];
    }
    var meta = (_a = Object.entries(user).find(function (entry) {
        return entry[0].endsWith("/metadata");
    })) === null || _a === void 0 ? void 0 : _a[1];
    return ((_b = meta === null || meta === void 0 ? void 0 : meta.authorizations) !== null && _b !== void 0 ? _b : []).map(function (a) { return a.organizationId; });
}
function loadChargerInfo(ocppId, orgIds, token) {
    var _a, _b, _c, _d, _e, _f, _g;
    return __awaiter(this, void 0, Promise, function () {
        var headers, getJson, siteId, anyListFailed, _i, orgIds_1, orgId, siteList, found, _h, details, telemetry, rawPricing, chargerDetails, model, chargerTelemetry, maxPowerKw, ports, mappedPorts, connectors, memberRate;
        var _this = this;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    headers = { authorization: "Bearer ".concat(token) };
                    getJson = function (path) { return __awaiter(_this, void 0, Promise, function () {
                        var resp;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL).concat(path), {
                                        method: "GET",
                                        headers: headers,
                                    })];
                                case 1:
                                    resp = _a.sent();
                                    if (!resp.ok) {
                                        throw new Error("GET ".concat(path, " failed (HTTP ").concat(resp.status, ")"));
                                    }
                                    return [4 /*yield*/, resp.json()];
                                case 2: return [2 /*return*/, (_a.sent())];
                            }
                        });
                    }); };
                    anyListFailed = false;
                    _i = 0, orgIds_1 = orgIds;
                    _j.label = 1;
                case 1:
                    if (!(_i < orgIds_1.length)) return [3 /*break*/, 4];
                    orgId = orgIds_1[_i];
                    return [4 /*yield*/, getJson("/site/list/".concat(orgId)).catch(function () {
                            anyListFailed = true;
                            return undefined;
                        })];
                case 2:
                    siteList = _j.sent();
                    found = (_a = siteList === null || siteList === void 0 ? void 0 : siteList.sites) === null || _a === void 0 ? void 0 : _a.find(function (s) { var _a; return (_a = s.chargerOcppIds) === null || _a === void 0 ? void 0 : _a.some(function (id) { return id.toLowerCase() === ocppId.toLowerCase(); }); });
                    if (found) {
                        siteId = found.id;
                        return [3 /*break*/, 4];
                    }
                    _j.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (siteId === undefined) {
                        throw new LoadError(anyListFailed ? "charger-info" : "charger-not-found");
                    }
                    return [4 /*yield*/, Promise.all([
                            getJson("/site/detail/".concat(siteId)).catch(function () {
                                throw new LoadError("charger-info");
                            }),
                            getJson("/site/telemetry/".concat(siteId)).catch(function () {
                                throw new LoadError("charger-info");
                            }),
                            getJson("/pricing/current/".concat(siteId)).catch(function () { return undefined; }),
                        ])];
                case 5:
                    _h = _j.sent(), details = _h[0], telemetry = _h[1], rawPricing = _h[2];
                    chargerDetails = (_b = details.chargers) === null || _b === void 0 ? void 0 : _b.find(function (c) { var _a; return ((_a = c.ocppId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ocppId.toLowerCase(); });
                    if (!chargerDetails) {
                        throw new LoadError("charger-info");
                    }
                    model = chargerDetails.model;
                    chargerTelemetry = (_c = telemetry.chargers) === null || _c === void 0 ? void 0 : _c.find(function (c) { var _a; return ((_a = c.ocppId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ocppId.toLowerCase(); });
                    maxPowerKw = (chargerTelemetry === null || chargerTelemetry === void 0 ? void 0 : chargerTelemetry.chargerAdvertisedMaxPower) ||
                        (chargerTelemetry === null || chargerTelemetry === void 0 ? void 0 : chargerTelemetry.chargerPowerHardcap);
                    ports = (_d = chargerTelemetry === null || chargerTelemetry === void 0 ? void 0 : chargerTelemetry.ports) !== null && _d !== void 0 ? _d : [];
                    if (!chargerTelemetry || !maxPowerKw || ports.length === 0) {
                        throw new LoadError("charger-info");
                    }
                    mappedPorts = ports.map(function (p, idx) { return ({
                        portId: idx + 1,
                        connectorType: normalizeConnectorLabel(PortTypeToString(p.portType)),
                        available: isPortAvailable(p),
                    }); });
                    connectors = isSinglePortModel(model)
                        ? mappedPorts.slice(0, 1)
                        : mappedPorts;
                    memberRate = rawPricing
                        ? formatMoneyPerKwh((_g = (_f = (_e = money.PricingModel.fromJSON(rawPricing).membershipPricing) === null || _e === void 0 ? void 0 : _e.defaultMembershipPricingModel) === null || _f === void 0 ? void 0 : _f.pricePerKwh) === null || _g === void 0 ? void 0 : _g.amount)
                        : undefined;
                    return [2 /*return*/, { connectors: connectors, maxPowerKw: maxPowerKw, memberRate: memberRate }];
            }
        });
    });
}
var ConnectorPlugIcon = function (_a) {
    var connectorType = _a.connectorType, selected = _a.selected;
    var isCcs = connectorType.toUpperCase().includes("CCS");
    var strokeColor = selected ? "#0053E2" : "#6B7280";
    if (isCcs) {
        return (React.createElement("svg", { width: "44", height: "24", viewBox: "0 0 44 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
            React.createElement("rect", { x: "1.5", y: "1.5", width: "41", height: "21", rx: "10.5", stroke: strokeColor, strokeWidth: "2" }),
            React.createElement("circle", { cx: "15", cy: "9", r: "1.5", fill: strokeColor }),
            React.createElement("circle", { cx: "22", cy: "9", r: "1.5", fill: strokeColor }),
            React.createElement("circle", { cx: "29", cy: "9", r: "1.5", fill: strokeColor }),
            React.createElement("circle", { cx: "15", cy: "15", r: "1.5", fill: strokeColor }),
            React.createElement("circle", { cx: "22", cy: "15", r: "1.5", fill: strokeColor }),
            React.createElement("circle", { cx: "29", cy: "15", r: "1.5", fill: strokeColor })));
    }
    return (React.createElement("svg", { width: "44", height: "24", viewBox: "0 0 44 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
        React.createElement("rect", { x: "1.5", y: "1.5", width: "41", height: "21", rx: "10.5", stroke: strokeColor, strokeWidth: "2" }),
        React.createElement("circle", { cx: "18", cy: "12", r: "2.2", fill: strokeColor }),
        React.createElement("circle", { cx: "26", cy: "12", r: "2.2", fill: strokeColor })));
};
var WalmartHeaderIllustration = function () { return (React.createElement("svg", { viewBox: "0 0 430 164", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "w-full block select-none", "aria-hidden": "true" },
    React.createElement("rect", { width: "430", height: "164", fill: "#0053E2" }),
    React.createElement("path", { d: "M-30 140 C 90 75, 250 75, 460 140 L 460 150 L -30 150 Z", fill: "#0046C7" }),
    React.createElement("path", { d: "M120 140 C 230 88, 360 88, 460 140 L 460 150 L 120 150 Z", fill: "#003EB3" }),
    React.createElement("rect", { x: "122", y: "114", width: "5", height: "26", fill: "#001E60" }),
    React.createElement("ellipse", { cx: "124.5", cy: "96", rx: "19", ry: "23", fill: "#FFC220" }),
    React.createElement("rect", { x: "308", y: "116", width: "4.5", height: "24", fill: "#001E60" }),
    React.createElement("ellipse", { cx: "310.25", cy: "100", rx: "16.5", ry: "20", fill: "#FFC220" }),
    React.createElement("rect", { x: "184", y: "30", width: "62", height: "108", rx: "6", fill: "#0041B6", stroke: "#66A3FF", strokeWidth: "1.5" }),
    React.createElement("g", { stroke: "#FFC220", strokeWidth: "2", strokeLinecap: "round" },
        React.createElement("line", { x1: "215", y1: "36", x2: "215", y2: "39.5" }),
        React.createElement("line", { x1: "215", y1: "44.5", x2: "215", y2: "48" }),
        React.createElement("line", { x1: "209.8", y1: "39", x2: "212.8", y2: "40.8" }),
        React.createElement("line", { x1: "217.2", y1: "43.2", x2: "220.2", y2: "45" }),
        React.createElement("line", { x1: "220.2", y1: "39", x2: "217.2", y2: "40.8" }),
        React.createElement("line", { x1: "212.8", y1: "43.2", x2: "209.8", y2: "45" })),
    React.createElement("rect", { x: "199", y: "53", width: "32", height: "43", rx: "3", fill: "#FFFFFF" }),
    React.createElement("rect", { x: "172", y: "135", width: "86", height: "5", rx: "1.5", fill: "#001E60" }),
    React.createElement("rect", { x: "0", y: "140", width: "430", height: "12", fill: "#FFC220" }),
    React.createElement("rect", { x: "0", y: "152", width: "430", height: "12", fill: "#0053E2" }))); };
export var WalmartCharge = function (_a) {
    var _b;
    var organizationId = _a.organizationId;
    var location = useLocation();
    var params = useParams();
    var _c = useAuth0(), user = _c.user, getAccessTokenSilently = _c.getAccessTokenSilently, loginWithRedirect = _c.loginWithRedirect;
    var searchParams = useMemo(function () { return new URLSearchParams(location.search); }, [location.search]);
    // The QR carries only ocppid and port. Everything else comes from Command Console.
    var ocppId = (params.ocppid ||
        searchParams.get("ocppid") ||
        searchParams.get("ocppId") ||
        "").trim();
    var portParam = Number(searchParams.get("port"));
    var requestedPort = Number.isInteger(portParam) && portParam >= 1 ? portParam : undefined;
    var firstName = useMemo(function () {
        if (user === null || user === void 0 ? void 0 : user.given_name) {
            return user.given_name;
        }
        if ((user === null || user === void 0 ? void 0 : user.name) && !user.name.includes("@")) {
            return user.name.split(" ")[0];
        }
        return undefined;
    }, [user]);
    var orgIdsKey = Array.from(new Set(__spreadArray([organizationId], organizationIdsFromUser(user), true).filter(function (id) { return typeof id === "number" && id > 0; }))).join(",");
    var _d = useState(0), reloadCount = _d[0], setReloadCount = _d[1];
    var loadKey = "".concat(ocppId, "|").concat(orgIdsKey, "|").concat(reloadCount);
    var _e = useState(), loadState = _e[0], setLoadState = _e[1];
    // A result for an older key (a different charger or a retry) counts as loading.
    var load = loadState && loadState.key === loadKey
        ? loadState.result
        : { status: "loading" };
    var _f = useState(requestedPort), pickedPort = _f[0], setPickedPort = _f[1];
    var _g = useState(false), submitting = _g[0], setSubmitting = _g[1];
    var _h = useState(false), authorized = _h[0], setAuthorized = _h[1];
    var _j = useState(null), errorMessage = _j[0], setErrorMessage = _j[1];
    // Fetching charger and pricing data from core-svc is external system
    // synchronisation, so it runs in an effect keyed by charger, orgs and retry.
    useEffect(function () {
        var cancelled = false;
        var finish = function (result) {
            if (!cancelled) {
                setLoadState({ key: loadKey, result: result });
            }
        };
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            var token, _a, orgIds, info_1, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!ocppId) {
                            finish({ status: "error", reason: "missing-ocppid" });
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getAccessTokenSilently({
                                authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                            })];
                    case 2:
                        token = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        finish({ status: "error", reason: "session" });
                        return [2 /*return*/];
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        orgIds = orgIdsKey ? orgIdsKey.split(",").map(Number) : [];
                        return [4 /*yield*/, loadChargerInfo(ocppId, orgIds, token)];
                    case 5:
                        info_1 = _b.sent();
                        finish({ status: "ready", info: info_1 });
                        return [3 /*break*/, 7];
                    case 6:
                        err_1 = _b.sent();
                        console.error("Walmart charge page failed to load charger info", err_1);
                        finish({
                            status: "error",
                            reason: err_1 instanceof LoadError ? err_1.reason : "charger-info",
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            cancelled = true;
        };
    }, [getAccessTokenSilently, loadKey, ocppId, orgIdsKey]);
    var info = load.status === "ready" ? load.info : undefined;
    var connectors = (_b = info === null || info === void 0 ? void 0 : info.connectors) !== null && _b !== void 0 ? _b : [];
    var isSinglePort = connectors.length === 1;
    // A single-port charger always uses its only port. Otherwise the port from the
    // QR (or the driver's pick) is used only when it matches a real port.
    var selectedConnector = isSinglePort
        ? connectors[0]
        : connectors.find(function (c) { return c.portId === pickedPort; });
    var holdDollars = (WALMART_DEMO_HOLD_CENTS / 100).toFixed(0);
    var startBlockedReason = !info
        ? undefined
        : !info.memberRate
            ? "Pricing unavailable, please try again."
            : !selectedConnector
                ? "Choose a connector to continue."
                : !selectedConnector.available
                    ? "This connector is unavailable."
                    : undefined;
    var canStart = info !== undefined &&
        startBlockedReason === undefined &&
        !submitting &&
        !authorized;
    var retry = function () {
        setErrorMessage(null);
        setReloadCount(function (count) { return count + 1; });
    };
    var signInAgain = function () {
        void loginWithRedirect({
            appState: {
                returnTo: window.location.pathname + window.location.search,
            },
        });
    };
    var handleConfirmAndCharge = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, token, _a, response, text, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!canStart || !selectedConnector) {
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    setErrorMessage(null);
                    body = {
                        portId: selectedConnector.portId,
                        amount: {
                            amount: WALMART_DEMO_HOLD_CENTS,
                            precision: 2,
                            currencyCode: "USD",
                        },
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        })];
                case 2:
                    token = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setErrorMessage(LOAD_ERROR_COPY.session);
                    setSubmitting(false);
                    return [2 /*return*/];
                case 4:
                    _b.trys.push([4, 9, 10, 11]);
                    return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL, "/pricing/authorize/").concat(encodeURIComponent(ocppId)), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(token),
                            },
                            body: JSON.stringify(body),
                        })];
                case 5:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 6];
                    setAuthorized(true);
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, response.text().catch(function () { return ""; })];
                case 7:
                    text = _b.sent();
                    console.error("Walmart charge authorization failed (HTTP ".concat(response.status, ")"), text);
                    setErrorMessage("We couldn't start charging. Please try again.");
                    _b.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    err_2 = _b.sent();
                    console.error("Walmart charge authorization request failed", err_2);
                    setErrorMessage("We couldn't start charging. Please try again.");
                    return [3 /*break*/, 11];
                case 10:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "min-h-screen w-full bg-white flex justify-center font-sans text-[#111827]", "data-testid": "walmart-charge-page" },
        React.createElement("div", { className: "w-full max-w-[430px] min-h-screen bg-white flex flex-col justify-between" },
            React.createElement("div", { className: "bg-[#0053E2] text-white overflow-hidden" },
                React.createElement("div", { className: "px-4 pt-3.5 pb-2 flex items-center justify-between" },
                    React.createElement("button", { type: "button", onClick: function () { return window.history.back(); }, className: "flex h-8 w-8 items-center justify-center rounded-full text-white transition-colors hover:bg-white/10", "aria-label": "Back" },
                        React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
                            React.createElement("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
                    React.createElement("span", { className: "text-[17px] font-bold tracking-tight text-white" }, "Walmart EV Charging"),
                    React.createElement("button", { type: "button", className: "flex h-8 w-8 items-center justify-center rounded-full text-white transition-colors hover:bg-white/10", "aria-label": "Help" },
                        React.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
                            React.createElement("circle", { cx: "12", cy: "12", r: "9.5", stroke: "currentColor", strokeWidth: "2" }),
                            React.createElement("path", { d: "M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.5628 13.8371 11.4708 12.9019 11.8327C12.3694 12.0387 12 12.5289 12 13.1V13.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                            React.createElement("circle", { cx: "12", cy: "16.75", r: "1.15", fill: "currentColor" })))),
                React.createElement("div", { className: "px-5 pt-2 pb-1" },
                    React.createElement("p", { className: "text-[15px] text-white/95 font-normal" }, firstName ? "Hi, ".concat(firstName) : "Hi"),
                    React.createElement("h1", { className: "text-[28px] font-bold leading-tight text-white mt-0.5" }, "Let's get started")),
                React.createElement(WalmartHeaderIllustration, null)),
            React.createElement("div", { className: "bg-white px-5 pt-6 pb-4 flex-1 flex flex-col" },
                load.status === "loading" && (React.createElement("p", { className: "text-center text-[16px] leading-snug text-[#4B5563] mb-4", "data-testid": "walmart-loading" }, "Loading charger...")),
                load.status === "error" && (React.createElement("div", { className: "rounded-lg bg-red-50 border border-red-200 px-3 py-3 text-center text-[14px] text-red-700", "data-testid": "walmart-load-error" },
                    React.createElement("p", null, LOAD_ERROR_COPY[load.reason]),
                    load.reason === "session" ? (React.createElement("button", { type: "button", onClick: signInAgain, className: "mt-2 underline font-bold" }, "Sign in again")) : load.reason === "charger-info" ? (React.createElement("button", { type: "button", onClick: retry, className: "mt-2 underline font-bold" }, "Try again")) : null)),
                info && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "text-center text-[16px] leading-snug text-[#1F2937] mb-4" }, selectedConnector ? (React.createElement(React.Fragment, null,
                        "You have chosen",
                        " ",
                        React.createElement("strong", { className: "font-bold text-[#111827]" },
                            "Connector ",
                            selectedConnector.portId,
                            selectedConnector.connectorType
                                ? ": ".concat(selectedConnector.connectorType)
                                : ""),
                        React.createElement("br", null),
                        "for your session")) : ("Choose a connector for your session")),
                    React.createElement("div", { className: "grid gap-3.5 ".concat(isSinglePort
                            ? "grid-cols-1 max-w-[200px] mx-auto w-full"
                            : "grid-cols-2"), "data-testid": "connector-options-grid" }, connectors.map(function (conn) {
                        var _a;
                        var isSelected = (selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.portId) === conn.portId;
                        return (React.createElement("button", { key: conn.portId, type: "button", "data-testid": "connector-card-".concat(conn.portId), onClick: function () { return setPickedPort(conn.portId); }, className: "flex flex-col items-center justify-center rounded-xl py-4 px-3 transition-all bg-white ".concat(isSelected
                                ? "border-2 border-[#0053E2]"
                                : "border border-[#D1D5DB] hover:border-[#9CA3AF]") },
                            React.createElement(ConnectorPlugIcon, { connectorType: (_a = conn.connectorType) !== null && _a !== void 0 ? _a : "", selected: isSelected }),
                            React.createElement("span", { className: "mt-2.5 text-[16px] font-bold text-[#111827]" }, conn.connectorType
                                ? "".concat(conn.portId, ": ").concat(conn.connectorType)
                                : "Connector ".concat(conn.portId)),
                            conn.available ? (React.createElement("span", { className: "mt-2 inline-block rounded-full bg-[#E6F4EA] px-3.5 py-0.5 text-[12px] font-semibold text-[#1E7E34]" }, "Available")) : (React.createElement("span", { className: "mt-2 inline-block rounded-full bg-[#F3F4F6] px-3.5 py-0.5 text-[12px] font-semibold text-[#6B7280]" }, "Unavailable"))));
                    })))),
                React.createElement("p", { className: "text-center text-[13px] text-[#374151] mt-4", "data-testid": "walmart-change-charger" }, "Need a different charger? Open your phone's camera app and scan the QR code on the charger."),
                React.createElement("div", { className: "flex-1 min-h-[24px]" }),
                info && (React.createElement("div", { className: "bg-[#F3F4F6] rounded-xl p-4 mt-5", "data-testid": "walmart-pricing" }, info.memberRate ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "flex items-center flex-wrap gap-2" },
                        React.createElement("span", { className: "bg-[#0053E2] text-white text-[11px] font-bold px-2.5 py-1 rounded-md" }, "Walmart+ member price"),
                        React.createElement("span", { className: "text-[#0053E2] text-[13px] font-semibold" }, info.memberRate)),
                    React.createElement("div", { className: "mt-2.5 flex items-center gap-1.5 text-[14px] font-bold text-[#111827]" },
                        React.createElement("svg", { width: "14", height: "16", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
                            React.createElement("path", { d: "M8.2 1L1.5 9.2H6.7L5.8 15L12.5 6.8H7.3L8.2 1Z", fill: "#FFC220", stroke: "#E5A800", strokeWidth: "0.8", strokeLinejoin: "round" })),
                        React.createElement("span", null,
                            info.maxPowerKw,
                            " kW max (",
                            info.memberRate,
                            ")",
                            " ",
                            React.createElement("span", { className: "underline" }, "current price"))),
                    React.createElement("p", { className: "mt-2 text-[12px] text-[#4B5563] leading-snug" }, "Applicable taxes are applied once charging completes."),
                    React.createElement("p", { className: "mt-1.5 text-[12px] text-[#4B5563] leading-snug" },
                        "A $",
                        holdDollars,
                        " temporary hold will be placed when the session starts."),
                    React.createElement("div", { className: "mt-0.5 text-[#6B7280]" },
                        React.createElement("svg", { width: "13", height: "13", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
                            React.createElement("circle", { cx: "8", cy: "8", r: "6.5", stroke: "currentColor", strokeWidth: "1.3" }),
                            React.createElement("line", { x1: "8", y1: "7.2", x2: "8", y2: "11.2", stroke: "currentColor", strokeWidth: "1.3", strokeLinecap: "round" }),
                            React.createElement("circle", { cx: "8", cy: "4.8", r: "0.8", fill: "currentColor" }))))) : (React.createElement("div", { className: "text-center text-[14px] text-[#374151]", "data-testid": "walmart-pricing-unavailable" },
                    React.createElement("p", { className: "font-semibold" }, "Pricing unavailable, please try again."),
                    React.createElement("button", { type: "button", onClick: retry, className: "mt-2 underline font-bold text-[#111827]" }, "Try again"))))),
                errorMessage && (React.createElement("div", { className: "mt-3 rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-xs text-red-700" }, errorMessage)),
                authorized && selectedConnector && (React.createElement("div", { className: "mt-3 rounded-lg bg-[#E6F4EA] border border-[#1E7E34]/30 px-3 py-2 text-center text-xs font-semibold text-[#1E7E34]", "data-testid": "walmart-auth-success" },
                    "\u2713 Charging authorized on ",
                    ocppId,
                    " (Connector",
                    " ",
                    selectedConnector.portId,
                    ")"))),
            React.createElement("div", { className: "px-5 pb-6 pt-2 bg-white" },
                startBlockedReason && !authorized && (React.createElement("p", { className: "mb-2 text-center text-[12px] text-[#4B5563]", "data-testid": "walmart-start-blocked-reason" }, startBlockedReason)),
                React.createElement("button", { type: "button", disabled: !canStart, onClick: handleConfirmAndCharge, "data-testid": "confirm-and-start-charging-btn", className: "w-full bg-[#0053E2] hover:bg-[#003da6] active:scale-[0.99] disabled:opacity-60 text-white font-bold text-[16px] py-3.5 rounded-full shadow-sm transition-all" }, submitting
                    ? "Starting..."
                    : authorized
                        ? "Charging started ✓"
                        : "Start charging")))));
};
export default WalmartCharge;
